import {FormioBase} from "./formiobase";

export class Currency extends FormioBase {
  public inputType = "number";
  public title = "Money";
  public icon = "fas fa-money-bill";
  public schema: any = {
    title: "currency",
    components: [{
      input: true,
      tableView: true,
      inputType: "number",
      label: "Money",
      key: "currencyField1",
      placeholder: "",
      prefix: "$",
      suffix: "",
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      clearOnHide: true,
      notvisible: false,
      kickbox: {
        enabled: false,
      },
      type: "currency",
      disabled: false,
      tags: [],
      validate: {
        required: false,
        min: "",
        max: "",
      },
      description: "",
      tooltip: "",
      customClass: "ds-currency",
    }],
  };
}
